// extracted by mini-css-extract-plugin
export default {"renter":"renter-caed"};